import { z } from "zod";
import { zNumber, zString } from "../../config/schemas/commonSchemaObjects";
const commonFields = {
  connector_id: zString.zRequired,
  name: zString.zRequired,
  study_ids: zString.zRequired,
  mode: zString.zRequired,
  data_format: zString.zRequired,
  username: zString.zRequired,
  password: zString.zRequired,
  mapping_id: zString.zRequired,
  secondary_mode: zString.zOptional,
  secondary_data_format: zString.zOptional,
  secondary_base_url: zString.zOptional,
  secondary_base_api_path: zString.zOptional,
  secondary_username: zString.zOptional,
  secondary_password: zString.zOptional,
  secondary_study_json_path: zString.zOptional,
  secondary_study_file_id: zString.zOptional,
  secondary_mapping_id: zString.zOptional,
  secondary_token_url: zString.zOptional,
  secondary_base_folder_path: zString.zOptional,
  secondary_sftp_host: zString.zOptional,
  secondary_sftp_port: zNumber.zOptional,
};
const specificFieldsAPI = {
  base_api_path: zString.zRequired,
  token_url: zString.zRequired,
  study_json_path: zString.zRequired,
  base_url: zString.zRequired,
};
const specificFieldsSFTP = {
  base_folder_path: zString.zRequired,
  sftp_host: zString.zRequired,
  sftp_port: zNumber.zRequired,
  study_file_id: zString.zRequired,
};
export const connectorSchemaAPI = z.object({
  ...commonFields,
  ...specificFieldsAPI,
});
export const connectorSchemaSFTP = z.object({
  ...commonFields,
  ...specificFieldsSFTP,
});
